import SodFunction from './SodFunction';

export default SodFunction;
